import { post, get, loginRequest } from './RequestAdapter';

export const accountService = {
  login,
  logout,
  register,
  getUsers,
  inviteUser,
  getInvitations,
  queryInvitation,
  resetPassword,
};

async function login(params) {
  const resp = await loginRequest(params);
  localStorage.setItem(
    'userInfo',
    JSON.stringify({ ...resp, roles: ['TenantAdmin'] }),
  );
  return resp;
}

async function register(
  firstName,
  lastName,
  displayName,
  email,
  password,
  invitationId,
) {
  let params = {
    body: {
      firstName: firstName,
      lastName: lastName,
      displayName: displayName,
      email: email,
      password: password,
      invitationId: invitationId,
    },
  };
  let register = await post('api/Account/Register', params);
  return register;
}

async function getUsers(token) {
  const auth = `Bearer ${token}`;
  let params = {
    token: auth,
  };
  let resp = await get('api/Account/Users', params);
  return resp;
}

async function inviteUser(
  token,
  firstName,
  lastName,
  email,
  tenantToJoinId,
  roleName,
) {
  const auth = `Bearer ${token}`;
  let params = {
    token: auth,
    body: {
      firstName: firstName,
      lastName: lastName,
      email: email,
      tenantToJoinId: tenantToJoinId,
      roleName: roleName,
    },
  };
  let resp = await post('api/Account/InviteUser', params);
  return resp;
}

async function getInvitations(token) {
  const auth = `Bearer ${token}`;
  let params = {
    token: auth,
  };
  let resp = await get('api/Account/UserInvitations', params);
  return resp;
}

async function queryInvitation(invitationId) {
  let params = {};
  let resp = await get(`api/Account/UserInvitations/${invitationId}`, params);
  return resp;
}

async function resetPassword(token, applicationUserId, password) {
  const auth = `Bearer ${token}`;
  let params = {
    token: auth,
    body: {
      newPassword: password,
      applicationUserId: applicationUserId,
    },
  };
  let resp = await post('api/Account/ResetPassword', params);
  return resp;
}

async function logout() {
  localStorage.removeItem('userInfo');
  localStorage.removeItem('userProfile');
  localStorage.removeItem('departmentSettings');
}
